import React from "react";
import styled from "styled-components";
import {
    BusinessPortalHeader,
    Button,
    PortalCaption,
    PortalMetricCard,
    PortalMetricGrid,
    PortalMetricLabel,
    PortalMetricValue,
    PortalSectionTitle,
    PortalSurface,
    portalColors,
} from "src/components";
import IconPencil from "src/img/new/pencil.svg";
import { GetManageButton } from "./style";
import PencilIcon from "src/img/edit@2x.png";

export const UpperButton = styled(Button)`
    border-radius: 10px;
    height: 2.4375rem;
    width: 140px;
    color: #fff;
    background-color: ${portalColors.text};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.2;
    white-space: nowrap;

    img {
        flex: 0 0 auto;
        margin-left: 0 !important;
    }
`;

export const MyQuotesHeader = (props) => {
    const { showManageQuotesModal, manageQuotes, quotes, featureName, setShowChangeNameDialog } = props;
    const handleManageQuotes = () => {
        showManageQuotesModal.toggleCreateQuoteForm();
    };
    if (!showManageQuotesModal) {
        return null; 
    }

    return (
        <>
            {!manageQuotes.showAddQuoteForm && (
                <>
                    <BusinessPortalHeader
                        title={featureName}
                        description="Create inspirational quotes with custom backgrounds, typography, colours, and optional linked articles for more context."
                    >
                            <UpperButton
                                backgroundColor="var(--calendar-action-primary-bg, #5B6EF5)"
                                onClick={() => setShowChangeNameDialog(true)}
                                style={{ margin: 0, borderRadius: 8 }}
                            >
                                Change Name{" "}
                                <img
                                    src={PencilIcon}
                                    height="13px"
                                    width="13px"
                                />
                            </UpperButton>
                    </BusinessPortalHeader>

                    <PortalSurface padding="1rem" style={{ marginBottom: "1rem" }}>
                        <PortalMetricGrid columns={2}>
                            <PortalMetricCard>
                                <PortalSectionTitle>Manage & Customise Quote Categories</PortalSectionTitle>
                                <PortalCaption>
                                    Control visible quote categories and create custom category titles for a more personal quote experience.
                                </PortalCaption>
                                <GetManageButton icon={IconPencil}
                                    onClick={() => handleManageQuotes()}
                                    style={{ marginTop: "0.85rem" }}
                                >
                                    Manage Quotes
                                    <img src={IconPencil} height="14px" width="14px" />
                                </GetManageButton>
                            </PortalMetricCard>
                            <PortalMetricCard background="var(--calendar-accent-soft, rgba(91,110,245,0.08))" border="var(--calendar-border-strong, #C9D2E7)">
                                <PortalMetricLabel>Available quotes</PortalMetricLabel>
                                <PortalMetricValue>{quotes.length || 0}</PortalMetricValue>
                            </PortalMetricCard>
                        </PortalMetricGrid>
                    </PortalSurface>
                </>
                
            )}  
        </>
    );
};
